import React from 'react';

export const useTabs = (defaultTab: string) => {
    const [current, setCurrent] = React.useState(defaultTab);
    return { current, setCurrent };
};
